<form clrForm clrLayout="vertical">
  <clr-radio-wrapper *ngFor="let button of buttonConfig.RadioButtons; index as i">
    <input type="radio" clrRadio name="option" required [value]="i" [(ngModel)]="selectedValue" (change)="radioButtonChanged($event)"/>
    <label>{{button.Label}}</label>
  </clr-radio-wrapper>
</form>
